module.exports = __webpack_public_path__ + "static/media/personThree.5d59d900.jfif";